import styled from 'styled-components';
const Kanit = 'Kanit, Helvetica Neue, Helvetica, Arial, sans-serif';

export const InputWrapper = styled.div`
  position: absolute;
  z-index: 999;
  width: 100%;
  bottom: -55px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  .btn-close-search {
    padding: 0;
    border: none;
    font-size: 16px;
    color: #333f48;
    font-weight: 500;
    line-height: normal;
    box-shadow: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${Kanit};
  }
  input {
    font-size: 16px;
    color: #697684;
    font-weight: 300;
    border: none;
    outline: none;
    width: 100%;
    height: 54px;
    line-height: 54px;
    padding: 0 16px;
    display: inline-flex;
    &::placeholder {
      color: #a5adb5;
      font-weight: 300;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
`;
